import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => {
    // keep the same height for all elements:
    // input, input track & fake track(div)
    const height = 6;
    const inputTrack = {
        background: 'transparent',
        height
    };
    const inputThumb = {
        background: theme.palette.text01,
        border: 0,
        borderRadius: '50%',
        height: 24,
        width: 24
    };
    const focused = {
        outline: `1px solid ${theme.palette.action03Focus}`
    };
    return {
        sliderContainer: {
            cursor: 'pointer',
            width: '100%',
            position: 'relative',
            textAlign: 'center'
        },
        knobContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 2,
            marginRight: 2,
            position: 'absolute',
            width: '100%'
        },
        knob: {
            background: theme.palette.text01,
            borderRadius: '50%',
            display: 'inline-block',
            height,
            width: 6
        },
        track: {
            background: theme.palette.ui02,
            borderRadius: Number(theme.shape.borderRadius) / 2,
            height
        },
        slider: {
            // Use an additional class here to override global CSS specificity
            '&.custom-slider': {
                '-webkit-appearance': 'none',
                background: 'transparent',
                height,
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                '&:focus': {
                    // override global styles in order to use our own color
                    outline: 'none !important',
                    '&::-webkit-slider-runnable-track': focused,
                    '&::ms-track': focused,
                    '&::-moz-range-track': focused
                },
                '&::-webkit-slider-runnable-track': Object.assign({ '-webkit-appearance': 'none' }, inputTrack),
                '&::-webkit-slider-thumb': Object.assign({ '-webkit-appearance': 'none', position: 'relative', top: -6 }, inputThumb),
                '&::ms-track': Object.assign({}, inputTrack),
                '&::-ms-thumb': Object.assign({}, inputThumb),
                '&::-moz-range-track': Object.assign({}, inputTrack),
                '&::-moz-range-thumb': Object.assign({}, inputThumb)
            }
        }
    };
});
/**
 *  Custom slider.
 *
 *  @returns {ReactElement}
 */
function Slider({ ariaLabel, max, min, onChange, step, value }) {
    const { classes, cx } = useStyles();
    const knobs = [...Array(Math.floor((max - min) / step) + 1)];
    return (React.createElement("div", { className: classes.sliderContainer },
        React.createElement("ul", { className: cx('empty-list', classes.knobContainer) }, knobs.map((_, i) => (React.createElement("li", { className: classes.knob, key: `knob-${i}` })))),
        React.createElement("div", { className: classes.track }),
        React.createElement("input", { "aria-label": ariaLabel, className: cx(classes.slider, 'custom-slider'), max: max, min: min, onChange: onChange, step: step, type: 'range', value: value })));
}
export default Slider;
